var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';
import map from 'lodash/map';
import FeatureFlagStore from 'stores/FeatureFlagStore/store';
import { FLAGS } from 'stores/FeatureFlagStore/types';
import Expectation from './Expectation';
import Stoplight from './Stoplight';
import NudgeButton from './NudgeButton';
var nudgeFlagEnabled = function () { return FeatureFlagStore.flag(FLAGS.NUDGE_BUTTON); };
var Expectations = /** @class */ (function (_super) {
    __extends(Expectations, _super);
    function Expectations(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: true, nudgeEnabled: nudgeFlagEnabled() };
        _this.toggleOpen = _this.toggleOpen.bind(_this);
        _this.onFlagsChange = _this.onFlagsChange.bind(_this);
        return _this;
    }
    // Subscribe to the flag store: flags load asynchronously (PostHog), so on a
    // direct page load the first render happens before flags arrive — without
    // the listener the nudge button would stay hidden until an unrelated
    // re-render (same pattern as ReadinessPanel). Only cards that can ever
    // show the button subscribe: the coach dashboard renders one card per
    // producer, and unconditional per-instance listeners blew the events-shim
    // 10-listener cap ("possible EventEmitter memory leak" console error) on
    // accounts with 8+ producers — while player/mobile cards (no userId) were
    // subscribing for a button they can never render.
    Expectations.prototype.componentDidMount = function () {
        if (this.canShowNudgeButton()) {
            FeatureFlagStore.addChangeListener(this.onFlagsChange);
        }
    };
    Expectations.prototype.componentWillUnmount = function () {
        if (this.canShowNudgeButton()) {
            FeatureFlagStore.removeChangeListener(this.onFlagsChange);
        }
    };
    Expectations.prototype.onFlagsChange = function () {
        this.setState({ nudgeEnabled: nudgeFlagEnabled() });
    };
    Expectations.prototype.getExpectations = function () {
        return map(this.props.expectations, function (expectation) {
            return (_jsx(Expectation, { goal: expectation.goal, actual: expectation.actual, frequency: expectation.frequency, isCurrency: expectation.isCurrency, productName: expectation.productName }, expectation.key));
        });
    };
    Expectations.prototype.getContent = function () {
        var result = '';
        if (this.state.open) {
            return (_jsx("div", { className: "sb-expectations-guts show", children: this.getExpectations() }));
        }
        return result;
    };
    Expectations.prototype.getHeader = function () {
        var _a, _b, _c, _d;
        var toggleClass = this.state.open ? 'ion-arrow-up-b' : 'ion-arrow-down-b';
        var toggle = (_jsx("span", { className: "sb-expectations-toggle", onClick: this.toggleOpen, children: _jsx("i", { className: toggleClass }) }));
        if (this.props.isCoachsArea) {
            var producerId = (_a = this.props.playerInfo) === null || _a === void 0 ? void 0 : _a.userId;
            var nudge = null;
            if (producerId !== undefined && this.state.nudgeEnabled) {
                nudge = (_jsx(NudgeButton, { producerId: producerId, producerName: (_b = this.props.playerInfo) === null || _b === void 0 ? void 0 : _b.name }));
            }
            return (_jsxs("header", { className: "sb-expectations-header", children: [_jsx("img", { className: "sb-expectations-profile-pic", src: (_c = this.props.playerInfo) === null || _c === void 0 ? void 0 : _c.profilePic, alt: "Profile pic" }), _jsx(Stoplight, { lowestPercentComplete: this.props.lowestPercentComplete }), _jsx("span", { className: "sb-expectations-header-title", children: (_d = this.props.playerInfo) === null || _d === void 0 ? void 0 : _d.name }), nudge, toggle] }));
        }
        return (_jsxs("header", { className: "sb-expectations-header", children: [_jsx("i", { className: "ion-flag" }), _jsx("span", { className: "sb-expectations-header-title", children: "My Expectations" }), _jsx(Stoplight, { lowestPercentComplete: this.props.lowestPercentComplete }), toggle] }));
    };
    Expectations.prototype.canShowNudgeButton = function () {
        var _a;
        return this.props.isCoachsArea && ((_a = this.props.playerInfo) === null || _a === void 0 ? void 0 : _a.userId) !== undefined;
    };
    Expectations.prototype.toggleOpen = function () {
        this.setState(function (prev) {
            return {
                open: !prev.open
            };
        });
    };
    Expectations.prototype.render = function () {
        var expectationCoach = classNames({
            'sb-expectations': true,
            'sb-expectations--coachs-area': this.props.isCoachsArea,
            'push-bottom': !this.props.isCoachsArea
        });
        return (_jsxs("div", { className: expectationCoach, children: [this.getHeader(), this.getContent()] }));
    };
    return Expectations;
}(React.Component));
export default Expectations;
